import { useTrackAnalyticsStore } from "@/stores/TrackAnalyticsStore";

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.client) {
    const trackAnalyticsStore = useTrackAnalyticsStore();

    const pathName = to.fullPath || "";
    const pathParams = to.params ? JSON.stringify(to.params) : "";

    const saveTrackAnalyticsParam = {
      path_module: to.meta.module,
      action: "PAGE ENTER",
      remark: "",
      val1: pathName,
      val2: pathParams,
      val3: "",
      val4: "",
      val5: "",
    };

    trackAnalyticsStore.saveTrackAnalytics(saveTrackAnalyticsParam);
  }
});
